<template>
  <div class="text-center">
      <provider-title :title="item.name"></provider-title>
      <span class="main" v-if="item.main">Casa Matriz</span>
      <p class="mt-2">
        {{item.address}}
        <br />
        <template v-if="item.commune_id">
          {{commune.name}}
          <br />
        </template>
        <template v-if="item.phone1">
        (+56) {{item.phone1 | phone_format}}
        <br />
        </template>
        <template v-if="item.phone2">
          <span>(+56) {{item.phone2 | phone_format}}</span>
          <br />
        </template>
      </p>
    </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
     ProviderTitle: () => import('@/components/providers/panel/ProviderTitle')
  },
  computed: {
    communes () {
      let all = []
      this.$store.getters.regions.forEach(region => {
        region.communes.forEach(comuna => {
          all.push(comuna)
        })
      })
      return all
    },
    commune() {
      return this.$store.getters.commune(this.item.commune_id)
    }
  },
}
</script>
